import _ from 'lodash';
import React from 'react';
import { withTranslation } from 'react-i18next';
import act from '@flux/actions/actView';
import EditPage from '../../EditPage';
import FormAppProfile from './AppProfileForm';

const AppProfilePage = props => {
  //#region Handlers
  /* const _handleTabChange = (event, tab) => {
    return setState({ activeTab: tab });
  }; */
  //#endregion

  //#region Render
  const _renderContents = () => {
    return _renderInformation();
  };

  const _renderInformation = () => {
    const additionalProps = {
      needs: [],
      fnPrepareSave: attrs => {
        const missingFields = [];
        if (attrs.name === null || attrs.name === undefined || attrs.name === '') {
          missingFields.push('Name');
        }
        if (missingFields.length !== 0) {
          act.notify({
            msg: `${props.t('Required fields missing')}: ${missingFields.join(', ')}`,
          });
        }
        return attrs;
      },
    };

    return (
      <EditPage
        {...Object.assign(
          {},
          props,
          {
            modelName: 'appProfile',
            collectionDataPath: 'appProfiles',
            FormComponent: FormAppProfile,
          },
          additionalProps,
          {
            entity: 'taAppProfile',
          }
        )}
      />
    );
  };

  //#endregion

  return <div className="Tabs">{_renderContents()}</div>;
};

export default withTranslation()(AppProfilePage);
